module.exports = __webpack_public_path__ + "static/media/AB_O1_10.a7c3111f.jpg";